import IconDate from "../../../assets/icon/element/element_calendar.svg";
import IconCheckbox from "../../../assets/icon/element/element_checkbox.svg";
import IconTime from "../../../assets/icon/element/element_clock.svg";
import IconDivide from "../../../assets/icon/element/element_divide.svg";
import IconDropdown from "../../../assets/icon/element/element_dropdown.svg";
import IconHeader from "../../../assets/icon/element/element_header.svg";
import IconLongText from "../../../assets/icon/element/element_long_text.svg";
import IconNumber from "../../../assets/icon/element/element_number.svg";
import IconRadio from "../../../assets/icon/element/element_radio.svg";
import IconShortText from "../../../assets/icon/element/element_short_text.svg";
import IconSign from "../../../assets/icon/element/element_sign.svg";

export enum ELEMENT_ID {
    // Basic
    HEADER = 'header',
    SHORT_TEXT = 'short-text',
    LONG_TEXT = 'long-text',
    NUMBER = 'number',
    DROPDOWN = 'dropdown',
    RADIO = 'radio',
    CHECKBOX = 'checkbox',
    DATE = 'date',
    TIME = 'time',
    DIVIDE = 'divide',

    // Defined
    SIGN = 'sign'
}

export const basicElements: IElement[] = [
    { id: ELEMENT_ID.HEADER, icon: IconHeader, name: 'Header' },
    { id: ELEMENT_ID.SHORT_TEXT, icon: IconShortText, name: 'Short text field' },
    { id: ELEMENT_ID.LONG_TEXT, icon: IconLongText, name: 'Long text field' },
    { id: ELEMENT_ID.NUMBER, icon: IconNumber, name: 'Number field' },
    { id: ELEMENT_ID.DROPDOWN, icon: IconDropdown, name: 'Dropdown' },
    { id: ELEMENT_ID.RADIO, icon: IconRadio, name: 'Single choice' },
    { id: ELEMENT_ID.CHECKBOX, icon: IconCheckbox, name: 'Multiple choice' },
    { id: ELEMENT_ID.DATE, icon: IconDate, name: 'Date picker' },
    { id: ELEMENT_ID.TIME, icon: IconTime, name: 'Time picker' },
    { id: ELEMENT_ID.DIVIDE, icon: IconDivide, name: 'Divide' },
]

export const definedElements: IElement[] = [
    { id: ELEMENT_ID.SIGN, icon: IconSign, name: 'Sign' },
]

export interface IElement {
    id: ELEMENT_ID
    icon: string
    name: string
}

export enum ELEMENT_TYPE {
    BASIC = 'basic',
    DEFINED = 'defined'
}

export const elementTypes = [
    { key: ELEMENT_TYPE.BASIC, name: 'Basic', opts: basicElements },
    { key: ELEMENT_TYPE.DEFINED, name: 'Defined component', opts: definedElements }
]

export enum SEPARATOR_VALUE {
    DASH = '-',
    SLASH = '/',
    DOT = '.'
}

export interface IPropsElement {
    isAllowSelect?: boolean
    index: number
    subIndex?: number
    type: ELEMENT_ID
    label: string
    properties: {
        required?: boolean
        multipleSelections?: boolean
        placeHolder?: string
        subLabel?: string
        options?: string
        optionDefault?: string[] | string
        numberOfColumns?: number
        numberOfRows?: number
        separator?: SEPARATOR_VALUE
        isShowTime?: boolean
        minuteStep?: number
        isCalendarPopup?: boolean
        isTimeRange?: boolean
        fontSize?: 'default' | 'large' | 'small'
        textAlign?: 'left' | 'center' | 'right'
    }
}

export const isHasLabel = new Set<ELEMENT_ID>([
    ELEMENT_ID.CHECKBOX,
    ELEMENT_ID.DATE,
    ELEMENT_ID.DROPDOWN,
    ELEMENT_ID.LONG_TEXT,
    ELEMENT_ID.NUMBER,
    ELEMENT_ID.RADIO,
    ELEMENT_ID.SHORT_TEXT,
    ELEMENT_ID.SIGN,
    ELEMENT_ID.TIME
])

export function initPropertiesElement(type: ELEMENT_ID): IPropsElement {
    const params = {
        type,
        label: '',
        properties: {}
    }
    switch (type) {
        case ELEMENT_ID.HEADER: {
            params.properties = {
                subLabel: '',
                fontSize: 'default',
                textAlign: 'left'
            }
            break;
        }
        case ELEMENT_ID.SHORT_TEXT: {
            params.properties = {
                required: true,
                placeHolder: '',
                subLabel: ''
            }
            break;
        }
        case ELEMENT_ID.LONG_TEXT: {
            params.properties = {
                required: true,
                placeHolder: '',
                subLabel: '',
                numberOfRows: 2
            }
            break;
        }
        case ELEMENT_ID.NUMBER: {
            params.properties = {
                required: true,
                placeHolder: '',
                subLabel: ''
            }
            break;
        }
        case ELEMENT_ID.DROPDOWN: {
            params.properties = {
                required: true,
                subLabel: '',
                multipleSelections: false,
                options: '',
            }
            break;
        }
        case ELEMENT_ID.RADIO: {
            params.properties = {
                required: true,
                subLabel: '',
                options: '',
                numberOfColumns: 1
            }
            break;
        }
        case ELEMENT_ID.CHECKBOX: {
            params.properties = {
                required: true,
                subLabel: '',
                options: '',
                numberOfColumns: 1
            }
            break;
        }
        case ELEMENT_ID.DATE: {
            params.properties = {
                required: true,
                separator: SEPARATOR_VALUE.SLASH,
                isCalendarPopup: true,
                isShowTime: false,
                subLabel: ''
            }
            break;
        }
        case ELEMENT_ID.TIME: {
            params.properties = {
                required: true,
                minuteStep: 1,
                isTimeRange: false,
                subLabel: ''
            }
            break;
        }
        case ELEMENT_ID.SIGN: {
            params.label = "Sign";
            params.properties = {
                subLabel: '',
                options: JSON.stringify([])
            }
            break;
        }
        default:
            params.properties = {}
    }
    return params as IPropsElement;
}

export function onChangeRequired(id: string) {
    const element: any = document.getElementById(id);
    element.click()
}

export const separatorOpts = [
    { label: SEPARATOR_VALUE.DASH, value: SEPARATOR_VALUE.DASH },
    { label: SEPARATOR_VALUE.SLASH, value: SEPARATOR_VALUE.SLASH },
    { label: SEPARATOR_VALUE.DOT, value: SEPARATOR_VALUE.DOT },
];
